import React, { useState } from 'react';
// import {operator} from '../components/affiliate';

function Todo({todo, index}) {
    return (
           
            <li class="card">
              <img src={todo.img} className="card-img-top" alt="..." />
              <div class="card-body">
                  <p className="card__price">{todo.pris}</p><span className="card__ordPrice">{todo.ordpris}</span>
                <h3 class="card__title">{todo.prodnamn}</h3>
                <p className="card__brodtext">{todo.text}</p>
                <a href={todo.buttonUrl} class="btn btn-warning" target="_blank" rel="noopener noreferrer">Köp nu</a>
              </div>
            </li>  
    )
}

function App() {
    // const namn = {operator};
    // console.log(namn.operator[0]);
    const [todos, setTodos] = useState([
        {
            img: '/antibite.png',
            pris: '295:-',
            ordpris: null,
            prodnamn: 'Antibite',
            text: 'Pengarn tillbaka om du inte är nöjd.',
            buttonUrl: 'https://adr.ec/sgggg_fW'
        },
        {
            img: 'https://beconfident.com/wp-content/uploads/2021/01/sleepright-dental-guard-secure-7350064161173.jpg',
            pris: '549:-',
            ordpris: null,
            prodnamn: 'Bettskena secure',
            text: 'Hållbar bettskena mot tandgnissling',
            buttonUrl: 'https://adr.ec/AUrLgg__R'
        },
        {
            img: 'https://beconfident.com/wp-content/uploads/2021/01/150300-Dental-Guard-Protect-bettskena.jpg',
            pris: '449:-',
            ordpris: null,
            prodnamn: 'Bettskena protect',
            text: 'Smidig bettskena mot tandgnissling.',
            buttonUrl: 'https://beconfident.com/sv/produkt/dental-guard-protect/'
        }
    ])

    return (
            <ul class="card-show">
                {todos.map((todo, index) => (
                <Todo key={index} index={index} todo={todo} /> 
                ))}
            </ul>
    )

}

export default App;